import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=1820c83b&scoped=true&"
import script from "./ScrollContainer.vue?vue&type=script&lang=ts&"
export * from "./ScrollContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=1820c83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820c83b",
  null
  
)

export default component.exports